/**
 * Detect whether an owner value refers to Calor Gas (not Callow / Callow Gas).
 * Tolerates common spelling mistakes: Callor, Caller, Callr, etc.
 */
export const isCalorOwner = (owner) => {
  if (!owner || typeof owner !== 'string') return false;

  const trimmed = owner.trim().toLowerCase();
  const compact = trimmed.replace(/[^a-z0-9]/g, '');

  if (!compact) return false;

  // Explicit exclusions — must not match Callow or Callow Gas
  if (compact.startsWith('callow')) return false;

  const withoutGas = compact.replace(/gas$/, '');

  const calorVariants = new Set([
    'calor',
    'callor',
    'caller',
    'callr',
    'calr',
  ]);

  if (calorVariants.has(withoutGas)) return true;

  // One-character typo tolerance against "calor" (e.g. "calo", "calors")
  if (withoutGas.length >= 4 && withoutGas.length <= 6) {
    const target = 'calor';
    let distance = 0;
    const maxLen = Math.max(withoutGas.length, target.length);
    for (let i = 0; i < maxLen; i += 1) {
      if (withoutGas[i] !== target[i]) distance += 1;
      if (distance > 1) break;
    }
    if (distance <= 1 && !withoutGas.startsWith('callow')) return true;
  }

  return false;
};
